/**************************************************
 * Nombre:       Blog_Recientes
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Chip, Grid, Typography} from "@mui/material";
import Tarjeta_Blog from "../../../Tarjetas/Tarjeta_Blog";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../../../Servicios/BD/obtenerCol";
import useRecuperarColleccionListeningProg from "../../../../Servicios/BD/useRecuperarColleccionListeningProg";
import {where} from "firebase/firestore";
import Tarjeta_Blog_Mini from "../../../Tarjetas/Tarjeta_Blog_Mini";

const Blog_Recientes = () => {
    const [categorias, setCategorias] = useState([]);
    const [escogidas, setEscogidas] = useState([]);
    const [wheres, setWheres] = useState([]);
    const {data} = useRecuperarColleccionListeningProg({
        col: 'blogs',
        wheres: wheres,
        orden: 'fechaPublicacion',
        direccion: 'desc'
    })


    const agregar = (it) => {

        let index = escogidas.findIndex(e => e === it);
        if (index === -1) {
            setEscogidas((arr) => arr.concat(it))
        }

    }

    const borrar = (nombre) => {
        setEscogidas([])
    }

    useEffect(() => {

        if (escogidas.length > 0) {
            let w = [where('categorias', 'array-contains-any', [...escogidas])];
            setWheres(w);
        } else {
            setWheres([]);
        }

    }, [escogidas])

    useEffect(() => {
        obtenerCol('categoriasBlog').then((dox) => {
            if (dox.res) {
                setCategorias(dox.data);
            }
        })
    }, [])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontWeight: 600}}>Blogs

                    {escogidas.length > 0 ?

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            spacing={1}
                            sx={{mt: 1}}
                        >

                            {escogidas.map((it, i) => (
                                <Chip label={it} variant={'filled'} color={'primary'} sx={{fontWeight: 400}}
                                      onDelete={() => borrar(it)}
                                />
                            ))}


                        </Grid>

                        :

                        <span style={{marginLeft: 5}}>Recientes</span>

                    }

                </Typography>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{mt: 2}}
                spacing={4}
            >

                {data.map((item, index) => (
                    <Grid container size={{xs: 12, sm: 6, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Tarjeta_Blog_Mini item={item}/>
                    </Grid>
                ))}

            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 6}}>
                <Typography sx={{fontWeight: 600}}>Categorias Blog</Typography>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{mt: 2}}
                spacing={1}
            >

                {categorias.map((it, index) => (
                    <Chip label={it.nombre} variant={'outlined'} color={'primary'} key={index}
                          onClick={() => agregar(it.nombre)}/>
                ))}

            </Grid>

        </Grid>
    )

}
export default Blog_Recientes

const items = [1, 2, 3]